import styled from "styled-components/macro";

export const Block = styled.div`
  border-radius: 20px;
`;
